import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useMemo } from 'react'

import { getFormattedAudiences } from './helper'

import { selectedFacebookAdAccountSelector } from '../../../../modules/selectors/adAccounts'
import { audiencesSelector } from '../../../../modules/selectors/audiences'
import { clearAudiences, getAudiences } from '../../../../modules/actions/audiences'

import { FACEBOOK_PLATFORM } from '../../../../constants/selectLists/platformList'

export const useLoadFacebookAudiences = () => {
  const dispatch = useDispatch()

  const { id: selectedAdAccountId } = useSelector(selectedFacebookAdAccountSelector)
  const audiences = useSelector(audiencesSelector)

  const formattedAudiences = useMemo(() => getFormattedAudiences(audiences), [audiences])

  useEffect(() => {
    dispatch(
      getAudiences(
        {
          account: selectedAdAccountId,
          limit: 9999
        },
        FACEBOOK_PLATFORM
      )
    )
  }, [dispatch, selectedAdAccountId])

  useEffect(() => {
    // clearAudiences on form closing
    return () => {
      dispatch(clearAudiences())
    }
  }, [dispatch])

  return formattedAudiences
}
